<template>
  <div class="material">

    <!-- Loading Animation START -->
    <div v-if="busy" class="full-box">
      <div class="loadingWorkOrders">
        <div class="logo"></div>
        <div class="loading-image"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"></i></div>
        Loading Material Entries for Work Order #{{this.$route.params.id}}        
      </div>
    </div>
    <!-- Loading Animation END -->

    <!-- Mobile Menu START -->
    <template v-if="openMenu">
      <div class="overlay">
        <div class="mobile-menu">
          <div class="inner">
            <div v-on:click="hideMenu()" class="close-menu"><i class="fa fa-times" aria-hidden="true"></i></div>
            <h2>{{username}}</h2>
            <ul>
              <li v-on:click="backToListings()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
              <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
            </ul>
          </div>
        </div>
      </div> 
    </template>
    <!-- Mobile Menu END -->

    <!-- Main Header START -->
    <div class="main-header">

      <div class="top">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">

            <!-- Tablet Header START -->
            <div v-if="$mq.resize && $mq.above($mv.tablet)">
              <button v-on:click="goBackToWO()" class="pull-right btn header-btn mcBG scBGHover"><i class="fa fa-reply" aria-hidden="true"></i> Back to the Work Order</button>
            </div>
            <!-- Tablet Header END -->

            <!-- Mobile Header START -->
            <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
              <ul>
                <li v-on:click="goBackToWO()"><i class="fa fa-reply" aria-hidden="true"></i></li>
                <li v-on:click="showMenu()"><i class="fa fa-bars" aria-hidden="true"></i></li>
              </ul>
            </div>
            <!-- Mobile Header END -->
              
            <div class="logo"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Main Header END -->

    <!-- Header Bar START -->
    <div class="inner-header-bar mcBG">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <img src="static/img/i3v_icon_white.png" class="pull-right">
              <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
                <h1>Enter Material <span>[WO# {{workOrder}}]</span> </h1>
              </div>
              <div v-if="$mq.resize && $mq.above($mv.tablet)">
                <h1>Enter Material - WO# {{workOrder}} </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Header Bar END -->

    <!-- Main Tablet View START -->
    <div v-if="$mq.resize && $mq.above($mv.tablet)" class="tablet-view">
      <div class="container">
        
        <div class="row flexrow">

          <!-- First Column START -> col-sm-5 -->
          <div class="col-sm-5">
            <div class="inner">

            <!-- If WO is Complete -> Show Completed Message -->
            <template v-if="workOrderCheck.fieldComplete">
              <h2>Work Order is closed</h2>
              <div class="form-group">
                <p>This Work Order is closed, so you will not be able to add any new <strong>material</strong> entries or edit any existing entries.</p>
              </div>
            </template>

            <!-- If WO is NOT Complete -> Show Form to Add/Edit Material Entries -->
            <template v-if="!workOrderCheck.fieldComplete">
              
              <h2>{{leftTitle}}</h2>

                <!-- Information to Show if Editing -->
                <div v-show="editing" class="form-group">
                  <p>{{introText}}<br> 
                  To add a <strong>NEW</strong> record, click <strong><span v-on:click="closeEdit()">here.</span></strong></p>
                </div>
              
                <!-- Hidden Fields -->
                <input type="hidden" v-model="edits.lineId">
                <input type="hidden" v-model="edits.uRecID">

                <!-- Material Selection -->
                <div class="form-group">
                  <label for="material">Select Material</label>
                  
                  <el-select v-model="edits.materialCode" popper-class="popClass" no-match-text="No Materials Found" filterable placeholder="Select Material">
                    <el-option class="form-control"
                      v-for="mat in orderBy(materials, 'description', 1)"
                      v-if="mat.uMMEnabled == true"
                      :label="mat.description + ' (' + mat.partNumber + ')'" 
                      :value="mat.materialCode">
                    </el-option>
                  </el-select>
                </div>

                <!-- Date -->
                <div class="form-group">
                  <label for="date">Date</label>
                  <el-date-picker
                    v-model="edits.date"
                    format="MM-dd-yyyy"
                    type="date"
                    placeholder="Pick a day">
                  </el-date-picker>
                </div>

                <!-- Quantity -->
                <div class="form-group">
                  <label for="quantity">Quantity</label><br>
                  <el-input-number size="small" v-model="edits.quantity" :min="1" :max="999"></el-input-number>
                </div>

                 <!-- Action Buttons -->
                <div class="form-group">
                  <button v-show="!editing" v-on:click="add()" type="button" class="mcBG scBGHover btn btn-primary">{{buttonTitle}}</button> 
                   <button v-show="editing" v-on:click="submitEdit()" type="button" class="mcBG scBGHover btn btn-primary">{{buttonTitle}}</button> 
                </div>

                 <!-- Loading Messages for Adding New Record/Editing Existing Record -->
                <div class="statusMSG form-group" v-show="busySave">
                  Saving New Record <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                </div>
                <div class="statusMSG form-group" v-show="busyEdit">
                  Editing Existing Record <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                </div>

                <!-- Error Message Holder -->
                 <div v-show="submitError" class="form-group">
                  <div class="error">
                    {{submitErrorText}}
                  </div>  
                </div>

              </template>

            </div>
          </div> 
          <!-- First Column END -> col-sm-5 -->

          <!-- Second Column START -> col-sm-4 -->
          <div class="col-sm-4">
            <div class="inner">
              <h2>Existing Records</h2>

              <!-- Loading Messages for Deleting an Existing Record -->
              <div class="statusMSG form-group" v-show="busyDel">
                Deleting Record <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
              </div>

              <!-- Listing of existing Material Records -->
              <ul class="innerWOListing">
                <li v-for="materialRecord in materialRecords" v-bind:class="{mcBGactive: editingRow == materialRecord.lineId}">

                  <!-- Show editing/deleting buttons only if WO is NOT closed -->
                  <div v-if="!workOrderCheck.fieldComplete">
                    <div class="actions">
                      <div v-on:click="edit(materialRecord.lineId,materialRecord.materialCode,materialRecord.quantity,materialRecord.useDate,materialRecord.uRecId)"><i class="mcTextHover fa fa-pencil-square-o" aria-hidden="true"></i></div>
                      <div v-on:click="del(materialRecord.lineId)"><i class="mcTextHover fa fa-times" aria-hidden="true"></i></div>
                    </div>
                  </div>

                  <div class="top-row">
                    {{nameOfMaterial(materialRecord)}}
                  </div>
                    Use Date: {{materialRecord.useDate | moment("MMM Do, YYYY") }} | Qty: {{materialRecord.quantity}}
                
                </li>
              </ul>

            </div>
          </div>
          <!-- Second Column END -> col-sm-4 -->

          <!-- Third Column START -> col-sm-3 -->
          <div class="col-sm-3">
            <div class="inner-dark">
              <h3 class="mcText"><span>Username</span>
              {{username}}</h3>
              <ul>
                <li v-on:click="backToListings()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
                <li v-on:click="enterLabor()">Enter Labor <i class="fa fa-user-circle" aria-hidden="true"></i></li>
                <li v-on:click="enterEquipment()">Enter Equipment <i class="fa fa-truck" aria-hidden="true"></i></li>
                <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
              </ul>
            </div>
          </div>
          <!-- Third Column END -> col-sm-3 -->

        </div>
      </div>
    </div> 
    <!-- Main Tablet View END -->

    <!-- Main Mobile View START -->
    <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
      <div class="mobile-view">

        <!-- Mobile Top Section START -->
        <div class="lem-formTop">

          <!-- If WO is Complete -> Show Completed Message -->
          <template v-if="workOrderCheck.fieldComplete">
            <h2>Work Order is closed</h2>
            <div class="form-group">
              <p>This Work Order is closed, so you will not be able to add any new <strong>material</strong> entries or edit any existing entries.</p>
            </div>
          </template>

          <!-- If WO is NOT Complete -> Show Form to Add/Edit Material Entries -->
          <template v-if="!workOrderCheck.fieldComplete">
            <h2>{{leftTitle}}</h2>

            <!-- Information to Show if Editing -->
            <div v-show="editing" class="form-group">
              <p>{{introText}}<br> 
              To add a <strong>NEW</strong> record, tap <strong><span v-on:click="closeEdit()">here.</span></strong></p>
            </div>

            <!-- Hidden Fields -->
            <input type="hidden" v-model="edits.lineId">
            <input type="hidden" v-model="edits.uRecID">

            <!-- Material Selection -->
            <div class="row">
              <div class="form-group col-xs-12">
                <label for="material">Select Material</label>

                <el-select v-model="edits.materialCode" popper-class="popClass" no-match-text="No Materials Found" filterable placeholder="Select Material">
                  <el-option class="form-control"
                    v-for="mat in orderBy(materials, 'description', 1)"
                    v-if="mat.uMMEnabled == true"
                    :label="mat.description + ' (' + mat.partNumber + ')'" 
                    :value="mat.materialCode">
                  </el-option>
                </el-select>

              </div>
            </div>

            <!-- Date, Start Time & Stop Time -->
            <div class="row">
              <div class="form-group col-xs-6">
                <label for="date">Date</label>
                <el-date-picker
                  :editable=false
                  v-model="edits.date"
                  format="MM-dd-yyyy"
                  type="date"
                  placeholder="Pick a day">
                </el-date-picker>
              </div>

              <!-- Quantity -->
              <div class="form-group col-xs-6">
                <label for="quantity">Quantity</label><br>
                <el-input-number size="small" v-model="edits.quantity" :min="1" :max="999"></el-input-number>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="row">
              <div class="form-group col-xs-12">
                <button v-show="!editing" v-on:click="add()" type="button" class="mcBG btn btn-primary">{{buttonTitle}}</button> 
                 <button v-show="editing" v-on:click="submitEdit()" type="button" class="mcBG btn btn-primary">{{buttonTitle}}</button> 
              </div>
            </div>
               
            <!-- Loading Messages for Adding New Record/Editing Existing Record -->
            <div class="row">
              <div class="statusMSG form-group col-xs-12" v-show="busySave">
                Saving New Record <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
              </div>
              <div class="statusMSG form-group col-xs-12" v-show="busyEdit">
                Editing Existing Record <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
              </div>
            </div>

          </template>
        </div>
        <!-- Mobile Top Section END -->

        <!-- Mobile Middle Info START -->
        <div class="lem-dividingCount">
          {{ materialRecords.length }} Records
        </div>
        <!-- Mobile Middle Info END -->

        <!-- Mobile Listing START -->
        <div class="lem-listingBottom">
            
            <!-- Loading Messages for Deleting an Existing Record -->
            <div class="statusMSG form-group" v-show="busyDel">
              Deleting Record <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
            </div>

              <!-- Listing of existing Material Records -->
              <ul class="innerWOListing">
                <li v-for="materialRecord in materialRecords" v-bind:class="{mcBGactive: editingRow == materialRecord.lineId}">

                  <!-- Show editing/deleting buttons only if WO is NOT closed -->
                  <div v-if="!workOrderCheck.fieldComplete">
                    <div class="actions">
                      <div v-on:click="edit(materialRecord.lineId,materialRecord.materialCode,materialRecord.quantity,materialRecord.useDate,materialRecord.uRecId)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
                      <div v-on:click="del(materialRecord.lineId)"><i class="fa fa-times" aria-hidden="true"></i></div>
                    </div>
                  </div>

                  <div class="top-row">
                    {{nameOfMaterial(materialRecord)}}
                  </div>
                    Use Date: {{materialRecord.useDate | moment("MMM Do, YYYY") }} | Qty: {{materialRecord.quantity}}
                </li>
              </ul>

      </div>
        <!-- Mobile Listing END -->
      </div>  

      <!-- Mobile Bottom BAR START 
      [[ This lists the number of LEMs and allows you to go to each page to post/view them ]] -->  
      <div class="mobileBottomBar">
        <div class="container">
          <div class="row">
            <div class="col-xs-4" v-on:click="enterLabor()">
              Labor <span class="mcText">({{ laborRecords.length }})</span>
            </div>
            <div class="col-xs-4 center" v-on:click="enterEquipment()">
              Equipment <span class="mcText">({{ equipmentRecords.length }})</span>
            </div>
            <div class="col-xs-4 active">
              Materials <span class="mcText">({{ materialRecords.length }})</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Bottom BAR END -->   
       
    </div>
    <!-- Main Mobile View END --> 

    <!-- Debug DATA START -->
    <pre v-show="false">
      {{ $data }}
    </pre>
    <!-- Debug DATA END -->
    
  </div> <!-- </material> -->
</template>

<script>
import Store from '../store'
import User from '../services/user'
import Datepicker from 'vuejs-datepicker'
import { getWorkOrder, getLabor, getEquipment, getMaterial, postMaterialRecord, deleteMaterialRecord, editMaterialRecord } from '../services/requests'

export default {
  name: 'materials',
  created() {

    // Loading Message True
    this.busy = true

    // Initial WO number
    this.workOrder = this.$route.params.id

    // Username to display on Mobile Menu/Third Column
    this.username = User.getUsername()

    // Grab WO information (for checking if WO is closed or not)
    getWorkOrder(this.$route.params.id)
      .toArray((workOrders) => {
        this.workOrderCheck = workOrders[0]
      }
    )

    getLabor(this.workOrder)
      .toArray((laborRecords) => {
        this.laborRecords = laborRecords
      })

    getEquipment(this.workOrder)
      .toArray((equipmentRecords) => {
        this.equipmentRecords = equipmentRecords
      })

    Store.whenMaterialsReady ( (materials) => {
      this.materials = materials

      getMaterial(this.workOrder)
        .toArray((materialRecords) => {
          this.materialRecords = materialRecords
          this.busy = false
        })
      
    })    
  },
  methods: {


     backToListings() {
      this.$router.push('/')
    },

    // Menu link to get back to the WO
    goBackToWO() {
      this.$router.replace('/workorder/' + this.workOrder)
    }, 

    // Main Method to Log Out
    logout() {
      User.logout()
      this.$router.replace('/login')
      alert('You have succesfully logged out!')
    },

    // Show/Hide Mobile Menus
    showMenu() {
      this.openMenu = true;
    },
    hideMenu() {
      this.openMenu = false;
    },

    enterLabor() {
      this.$router.push('/workOrder/labor/' + this.$route.params.id)
    },
    enterEquipment() {
      this.$router.push('/workOrder/equipment/' + this.$route.params.id)
    },

    nameOfMaterial(lineItem) {
      let name = ''
      this.materials.forEach((material) => {
        if (material.materialCode == lineItem.materialCode) {
          name = material.description
        }
      })
      return name
    },


    del(lineId) {
      
      this.leftTitle = "Enter New Record"
      this.buttonTitle = "Add New Record"
      this.editing = false
      this.busyDel = true

      let record = {
        systemCode: User.getSystemCode(),
        woNumber: this.workOrder,
        lineId: lineId,
      }

      deleteMaterialRecord(this.workOrder, record)
        .stopOnError((err) => {
          
          var errorArray = JSON.parse(err.message)
          this.errorArray = errorArray
          alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)

          this.busyDel = false
        })
        .done(() => {
           
          getMaterial(this.workOrder)
          .toArray((materialRecords) => {
            this.materialRecords = materialRecords
            this.busyDel = false


          })

      }) // deleteLaborRecord END

    },

    edit(lineId,materialCode,quantity,useDate,uRecID) {

      this.editingRow = lineId

      this.leftTitle = "Edit Existing Record"
      this.buttonTitle = "Edit Record"
      this.introText = "You are now editing an existing record"
      this.editing = true
      
      this.edits.materialCode = materialCode
      this.edits.quantity = quantity

      let d = new Date();
      let n = d.getTimezoneOffset(); 

      useDate = new Date(useDate)
      var useDateFixed = new Date(useDate.getTime() + n*60000);

      // useDate = new Date(useDate.getTime() + 1000)
      this.edits.date = useDateFixed

      this.edits.lineId = lineId
      this.edits.uRecID = uRecID

      window.scrollTo(0,0);

    },
    closeEdit() {
      this.leftTitle = "Enter New Record"
      this.buttonTitle = "Add New Record"
      this.editing = false
      this.editingRow = ''
    },
    submitEdit() {
      
      this.busyEdit = true

      let now = new Date()

      let record = {
        uRecId: this.edits.uRecID,   
        systemCode: User.getSystemCode(),
        woNumber: this.workOrder,
        lineId: this.edits.lineId,       
        materialCode: this.edits.materialCode,
        useDate: this.edits.date, 
        quantity: this.edits.quantity,
        createdOn: now.toISOString(),
        updatedOn: now.toISOString(),
      }

      editMaterialRecord(this.workOrder, record)
        .stopOnError((err) => {
          
          var errorArray = JSON.parse(err.message)
          this.errorArray = errorArray
          alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)

          this.busyEdit = false

        })
        .done(() => {
           
          getMaterial(this.workOrder)
          .toArray((materialRecords) => {
            this.materialRecords = materialRecords

            this.busyEdit = false
            this.leftTitle = "Enter New Record"
            this.buttonTitle = "Add New Record"
            this.editing = false
            this.editingRow = ''
            this.edits.materialCode
          })



        }) // done
    },

    add() {
      this.busySave = true

      let now = new Date()

      var parsedDate = new Date(this.edits.date).toISOString();

      let record = {
        uRecId: '',   
        systemCode: User.getSystemCode(),
        woNumber: this.workOrder,
        lineId:0,       
        materialCode: this.edits.materialCode,
        useDate: parsedDate, 
        quantity: this.edits.quantity,
        createdOn: now.toISOString(),
        updatedOn: now.toISOString(),
      }

    
      postMaterialRecord(this.workOrder, record)
        .stopOnError((err) => {
          
          var errorArray = JSON.parse(err.message)
          this.errorArray = errorArray
          alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)
          
          this.busy = false
        })
        .done(() => {

          getMaterial(this.workOrder)
          .toArray((materialRecords) => {
            this.materialRecords = materialRecords

            this.busySave = false
            this.edits.materialCode = ""
          })

           
        })
      }
  },
  components: {
    Datepicker
  },
  data () {
    return {
      record: [],
      workOrderCheck: [],
      openMenu: false,
      busy: true,
      leftTitle: 'Enter New Record',
      buttonTitle: 'Add New Record',
      introText: '',
      submitErrorText: '',
      submitError: false,
      editing: false,
      busyDel: false,
      busySave: false,
      busyEdit: false,
      editingRow: '',
      time: '',
      workOrder: '',
      materialRecords: [],
      equipmentRecords: [],
      laborRecords: [],
      materials: [],
      edits: {
        materialCode: '',
        date: '',
        quantity: '1'
      }
    }
  }
}
</script>

<style scoped>
.material {
 padding-top: 102px;
  position: relative;
}

.mobileBottomBar {
  display: none;
}

  .material .main-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
    padding: 0;
  }

.material .main-header .top {
  background: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  }

  .material .header-btn {
    color: #fff;
    font-family: 'open_sanssemibold';
    font-size: 12px;
    margin-left: 10px;
  }

    .material .header-btn i {
      margin-right: 5px;
    }

    .tablet-view {
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .tablet-view .form-group {
      padding: 0 20px;
      margin: 15px 0;
    }

    .tablet-view .form-group .form-control {
      background: #eef2f4;
      font-size: 13px;
      color: #666;
    }

     .tablet-view .datepicker input {
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
        color: #555;
        display: block;
        font-size: 14px;
        height: 34px;
        line-height: 1.42857;
        padding: 6px 12px;
        transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
        width: 100% !important;
        background: #eef2f4;
        font-size: 13px;
        color: #666;
     }

    .tablet-view .form-group .btn {
      color: #fff;
      border: 0;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
        margin: 0 auto;
        display: block;
    }

    .tablet-view .form-group strong span {
      cursor: pointer;
    }

.innerWOListing,
.innerWOListing li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.innerWOListing li {
  padding: 12px 10px 12px 20px;
  color: #010101;
}

.innerWOListing li:nth-of-type(even) {
  background: #f9f9f9;
}

.innerWOListing li strong {
  display: inline-block;
  font-family: 'open_sansbold';
  font-weight: normal;
  text-transform: uppercase;
}

.innerWOActions,
.innerWOActions li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

  .innerWOActions {
    margin-bottom: 40px;
    }

  .innerWOActions li {
    padding: 15px 10px 15px 20px;
    font-size: 18px;
    color: #010101;
    cursor: pointer;
  }

  .innerWOActions li i {
    color: #666;
    margin-right: 10px;
  }

  .innerWOActions li:nth-of-type(even) {
    background: #f3fbff;
  }

.innerWOListing li .actions {
  float: right;
  font-size: 21px;
}

.innerWOListing li.mcBGactive {
    display: block;      
    color: #fff !important;
  }     

.innerWOListing li.mcBGactive i {
    color: #fff !important;
  }

@media only screen and (max-width : 768px) {



  .innerWOtopRow {
    text-align: center;
  }

  .innerWOtopRow .row {
    display: flex;
    font-size: 17px;
  font-family: 'open_sanssemibold';
  }

  .innerWOtopRow .left {
    background: #e7e7e7;
    border-bottom: #d4d1d1 solid 4px;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .innerWOtopRow .right {
    padding-top: 30px;
    padding-bottom: 30px;
  } 

  .innerWOtopRow h5 {
  font-size: 11px;
  color: #999;
  text-transform: uppercase;
  margin: 0;
  padding: 0 0 5px 0;
  }

  .innerWOtopRow .right h5 {
    color: #e9e9e9;
    }

   .innerWOmainListing {
     margin: 20px 0px;
     text-align: center;
     font-size: 14px;
   } 

   .innerWOmainListing p {
    margin: 0 0 3px;
    padding: 0 5px;
   }

   .innerWOmainListing strong {
   font-weight: normal;
   font-family: 'open_sanssemibold';
   }

   .innerWOmainListing p.priorityHigh {
    background: #cc0000;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWOmainListing p.priorityMedium {
      background: #ff9900;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWOmainListing p.priorityScheduled {
      background: #66cc00;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWoCompletion {
    background: #f8f8f8;
    padding: 25px;
   }


    .innerWoCompletion .form-group .form-control {
      background: #eef2f4;
      font-size: 13px;
      color: #666;
    }

    .innerWoCompletion .form-group .btn {
      color: #fff;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
        margin: 0 auto;
        display: block;
    }
  
}









.loadingWorkOrders {
  text-align: center;
  font-size: 17px;
  font-family: 'open_sanssemibold';
  padding-top: 20px;
}

  .loadingWorkOrders img {
    display: block;
    margin: 0 auto 10px;
  }


  #woListing {
    width: 100%;
  }

  #woListing ul,
  #woListing ul li {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 100%;
  }

    #woListing ul li {
      padding: 10px 0 10px 50px;
      background-image: url(../../static/img/icon-wo-open.png);
      background-repeat: no-repeat;
      background-position: 15px center;    
      cursor: pointer;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900;
    }

    #woListing ul li .woTopRow {
      font-size: 16px;
    }

    #woListing ul li:nth-child(odd) {
      background-color: #eaeaea;
    }

     #woListing ul li strong {
     font-weight: normal;
     font-family: 'open_sansbold';
     }

      #woListing ul li img {
        padding-top: 30px;
      }

.tablet-view {
  background: #f5f8fb;
}

.flexrow {
  display: flex;
}

  .tablet-view .tabletSortSearchRow {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 12px; 
    font-family: 'open_sanssemibold';
  }

    .tablet-view .tabletSortSearchRow a {
      display: inline-block;
      margin: 0 0 5px;
      padding: 3px 10px;
      text-decoration: none;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }

    .tablet-view .tabletSortSearchRow a.active {
      color: #fff;
    }

    .tablet-view .tabletSortSearchRow .form-control {
      max-width: 70%;
      display: inline-block;
      margin-left: 10px;
      height: 26px;
      font-size: 12px;
      background-color: #e7edf2;
      border: 0;
    }

    .tablet-view .tabletSortSearchRow .btn {
      max-width: 10%;
      color: #fff;
    }

    .tablet-view .inner {
       background: #fff;
       min-height: 100%;
    }

    .tablet-view .inner-dark {
      background: #212121;
      color: #fff;
      padding: 5px;
      text-align: center;
      min-height: 100%;
    }

      .tablet-view .inner-dark h3 {
        border-top: #555 solid 2px;
        border-bottom: #555 solid 2px;
        padding: 10px 0;
        margin: 0;
        font-size: 16px;
        color: #00b7e3;
         font-family: 'open_sanssemibold';
      }

      .tablet-view .inner-dark h3 span {
        font-size: 11px;
        text-transform: uppercase;
        color: #777;
        display: block;
        margin-bottom: 5px;
      }

      .tablet-view .inner-dark ul,
      .tablet-view .inner-dark ul li {
        margin: 0;
        padding: 0;
        list-style-type: none;
        text-align: right;
      }

       .tablet-view .inner-dark ul {
        padding-right: 20px;
        padding-top: 10px;
       }

        .tablet-view .inner-dark ul li {
          color: #fff;
          padding: 10px 0;
          cursor: pointer;
        }

        .tablet-view .inner-dark ul li i {
          margin-left: 5px;
          color: #999;
        }

    .tablet-view h2 {
      margin: 0;
      padding: 20px;
      font-size: 20px;
      border-bottom: 1px solid #ccc;
      font-family: "ralewayblack";
      text-transform: uppercase;
    }

    .tablet-view .completedtrue {
      border: 0 !important;
      background-image: none !important;
      padding: 10px 0 10px 10px !important;
    }

    .tablet-view .completedtrue:nth-child(odd) {
      background-color: #f3fbff !important;
    }

.mobile-view .completedtrue {
  background: #333 !important;
  color: #ccc;
  border-bottom: 1px dotted #666;
}
    .mobile-view .completedtrue .woTopRow {
      color: #fff;
    }


@media only screen and (max-width : 768px) {
  #woListing ul li img {
    padding-top: 40px;
  }

    #woListing ul li {
      font-size: 11px;
      background-position: 10px center;
      padding: 10px 0 10px 30px;
    }

    #woListing ul li .woTopRow {
      font-size: 13px;
    }

    #woListing ul li.completedtrue {
      background-image: url(../../static/img/icon-wo-closed.png) !important;
      background-color: #333 !important;
      background-repeat: no-repeat !important;
      background-position: 10px center !important;
      border-left: 8px solid #006600 !important;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000 !important;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00 !important;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900 !important;
    }

  .mobileBottomBar {
    background: #fff;
    position: fixed;
    bottom: 0px;
    display: block;
    z-index: 2;
    width: 100%;
    text-align: center;
    cursor: pointer;
    padding-top: 00px;
     -webkit-box-shadow: 0px -3px 5px #666;
    -moz-box-shadow:    0px -3px 5px #666;
    box-shadow:         0px -3px 5px #666;
    font-family: 'open_sanssemibold';
    font-size: 15px;
    color: #999;
  }

  .mobileBottomBar .col-xs-4 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .mobileBottomBar .active {
    background-color: rgba(99, 99, 99, 0.639);
    color: white;
  }

  .mobileBottomBar .center {
    border-left: 2px solid #ddd;
    border-right: 2px solid #ddd;
  }

  .mobileBottomBar span {
    display: block;
    font-size: 12px;
  }

  .mobile-sort {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    max-width: 75%;
    min-width: 50%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
  }

    .mobile-sort h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-sort p {
      display: block;
      margin: 0;
      padding: 10px 0;
      border-bottom: 1px solid #ddd;
    }

    .mobile-sort p:last-of-type {
      border-bottom: 0px;
    }

    .mobile-sort p a {
    display: block;
    color: #333;
    text-decoration: none;
    font-family: 'open_sanssemibold';
    }

    .mobile-sort p a.active {
      font-family: 'open_sansbold';
      text-transform: uppercase;
    }

  .mobile-search {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 90%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
    font-family: 'open_sansbold';
  }

    .mobile-search h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-search input {
    margin-bottom: 20px;
    text-align: center;
    }

    .mobile-search a.btn {
      font-family: 'open_sansbold' !important;
      font-size: 16px;
      color: #fff;
      text-transform: uppercase;
    }

}

.full-box {
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 5;
}

  .full-box .loadingWorkOrders {
    margin-top: 100px;
  }

  .full-box .main-logo {
    max-width: 150px;
  }

  .form-control.small{
 width: 60px;
 display: inline-block;
 text-align: center;
}

.innerWOListing li .top-row {
  font-size: 13px;
 text-transform: uppercase;
}

.innerWOListing li {
  font-size: 12px;
}

.innerWOListing li .actions {
  float: right;
  font-size: 21px;
}

.innerWOListing li .actions div {
  display: inline-block;
}

.innerWOListing li .actions i {
  margin: 0 0 0 10px;
}

.innerWOListing li .actions i:hover {
  cursor: pointer;
}

.statusMSG {
  text-align: center;
  font-size: 15px;
}

.edit-box {
  background: #fff;
  -webkit-border-radius: 10px;
-moz-border-radius: 10px;
border-radius: 10px;
max-width: 500px;
margin: 30px auto 0;
padding-bottom: 20px;
}

.lem-formTop {
  background: #f8f8f8;
  padding: 15px;
  text-align: center;
}

.lem-formTop input,
.lem-formTop select {
  text-align: center;
}

.lem-formTop .form-control.small{
 width: 30px;
 display: inline-block;
 text-align: center;
 padding: 6px 0;
}

 .lem-formTop h2 {
      margin: 0;
      padding: 10px 0;
      font-size: 20px;
      font-family: "ralewayblack";
      text-transform: uppercase;
    }

    .lem-formTop .btn {
      border: 0;
      color: #fff;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
         margin-top: 25px;
        display: block;
        width: 100%;
    }

.lem-dividingCount {
  padding: 5px 0;
  text-align: center;
  font-family: 'open_sanssemibold';
  color: #fff;
  background: #333;
  text-transform: uppercase;
}

.el-select, .el-input {
    width: 100%;
    font-size: 12px;
  }

.el-input-number--small {
  width: 100%;
}


</style>



// WEBPACK FOOTER //
// Materials.vue?02d2503e